export enum LegBraceSideEnum {
  Front = 'front',
  Back = 'back',
  Left = 'left',
  Right = 'right',
  EndWallFront = 'endwall-front',
  EndWallBack = 'endwall-back',
  EndWallLeft = 'endwall-left',
  EndWallRight = 'endwall-right',
}
